import React, { useState, useEffect } from "react";
import { isMobile } from "react-device-detect";
import AOS from "aos";
import { Link } from "react-router-dom";
import "aos/dist/aos.css";
import banner from "./images/Blog-banner2.png";

import blogthumb1 from "./images/blogthumb1.png";
import blogthumb2 from "./images/blogthumb2.png";
import BlogThumbnail from "./images/Blog-Thumbnail.jpg";
import blogthumb4 from "./images/blogthumb4.jpg";
import blogthumb5 from "./images/blogthumb5.jpg";
import blogthumb6 from "./images/blogthumb6.jpg";
import blogthumb7 from "./images/blogthumb7.jpg";
import blogthumb8 from "./images/modular-blog-thumb-1.jpg";
import blogthumb9 from "./images/interior-blog-thumb-1.jpg";
import blogthumb10 from "./images/Luxury-Lives-in-the-Details-thumb.jpg";
import blogthumb11 from "./images/blogthumb11-thumb.jpg";
import blogthumb13 from "./images/blogthumb13-thumb.jpg";

import OnloadPopup from "./OnloadPopup";

AOS.init({
  disable: isMobile,
});

const blogs = [
  {
    id: 1,
    slug: "The-Future-of-Home-Design",
    title: "The Future of Home Design: ",
    subtitle: "Why Modular Interiors Lead the Way",
    publishedDate: "15-February-2025",
    image: blogthumb1,
    description:
      "Discover the elegance and functionality of modern cabinets for every space.",
  },
  {
    id: 2,
    slug: "Modular-Interiors",
    title: "Modular Interiors",
    subtitle: "Transforming Homes with Style and Functionality",
    publishedDate: "15-March-2025",
    image: blogthumb2,
    description:
      "Explore how minimalist kitchen designs can transform your home.",
  },
  {
    id: 3,
    slug: "The-Real-Cost-of-Custom-Interiors",
    title: "The Real Cost of Custom Interiors",
    subtitle: "What You’re Not Being Told",
    image: BlogThumbnail,
    publishedDate: "15-April-2025",
    description:
      "Explore how minimalist kitchen designs can transform your home.",
  },
  {
    id: 4,
    slug: "Smart-Storage-7-Modular-Design-Ideas",
    title:
      "Smart Storage - 7 Modular Design Ideas That Save Space & Look Great",
    subtitle: "Let us acknowledge a common reality: ",
    image: blogthumb4,
    publishedDate: "15-May-2025",
    description:
      "Explore how minimalist kitchen designs can transform your home.",
  },

  {
    id: 5,
    slug: "From-Moodboard-to-Modular-How-We-Bring-Your-Vision-to-Life",
    title: "From Moodboard to Modular – How We Bring Your Vision to Life",
    subtitle: "Every dream home starts with a li􏰁le spark ",
    image: blogthumb5,
    publishedDate: "01-June-2025",
    description:
      "Every dream home starts with a li􏰁le spark — maybe it’s an inspiring image on Pinterest, a special magazine clipping,",
  },

  {
    id: 6,
    slug: "Mistakes-to-Avoid-When-Designing-Your-Kitchen",
    title: "Mistakes to Avoid When Designing Your Kitchen",
    subtitle:
      "Designing a kitchen can be such an exciting part of your home interior journey! However, ",
    publishedDate: "10-June-2025",
    image: blogthumb6,
    description:
      "Designing a kitchen can be such an exciting part of your home interior journey! However, it’s also an area where mistakes can end up cosing you quite a bit.",
  },

  {
    id: 7,

    slug: "Wardrobes-That-Enhance-Functionality-A-Comprehensive-Guide-to-Effective-Storage-Design",
    title:
      "Wardrobes That Enhance Functionality - A Comprehensive Guide to Effective Storage Design",
    subtitle:
      "A wardrobe serves as more than merely a place for hanging garments; ",
    publishedDate: "16-June-2025",
    image: blogthumb7,
    description:
      "A wardrobe serves as more than merely a place for hanging garments;",
  },

  {
    id: 8,

    slug: "Modular-vs-Carpenter-Made-What-Every-Homeowner-Should-Know",
    title: "Modular vs Carpenter-Made: What Every Homeowner Should Know",
    subtitle:
      "When it comes to designing your dream home — especially kitchens,",
    publishedDate: "24-June-2025",
    image: blogthumb8,
    description:
      "wardrobes, and storage — one of the most important decisions is how it’s built: modular factory-made or traditional carpenter-made",
  },

  {
    id: 9,

    slug: "Interior-Trends-for-2025",
    title: "Interior Trends for 2025: What’s In, What’s Out",
    subtitle: "Interior design in 2025 is all about intentional living. ",
    publishedDate: "01-July-2025",
    image: blogthumb10,
    description:
      "Spaces are becoming smarter, sleeker, and more in tune with the people who live in them. As technology blends with craftsmanship and design moves toward minimalism with depth, this year’s trends are clear: form must serve function, and beauty must have purpose.",
  },

  {
    id: 10,

    slug: "Luxury-Lives-in-the-Details",
    title: "Luxury Lives in the Details: Why Finish Matters in Your Interiors",
    subtitle:
      "When we think of luxury interiors, we often picture spacious rooms, stylish furniture, or curated lighting.",
    publishedDate: "10-July-2025",
    image: blogthumb9,
    description:
      "When we think of luxury interiors, we often picture spacious rooms, stylish furniture, or curated lighting. ",
  },
  {
    id: 11,

    slug: "Why-In-House-Manufacturing",
    title: "Why In-House Manufacturing Is the Future of Premium Interiors",
    subtitle:
      "The world of interiors is evolving — fast. Today’s homeowners no longer settle for guesswork, delays, or patchwork craftsmanship.",
    publishedDate: "16-July-2025",
    image: blogthumb10,
    description:
      "The world of interiors is evolving — fast. Today’s homeowners no longer settle for guesswork, delays, or patchwork craftsmanship. They expect precision, consistency, and a seamless experience from design to installation. And in this new era, in-house manufacturing isn’t just an advantage — it’s the new standard for premium interiors. ",
  },
  {
    id: 12,

    slug: "From-Kitchen-to-Utility",
    title: "From Kitchen to Utility: Why Every Zone Deserves Modular Attention",
    subtitle:
      "When considering modular interiors, the initial association is frequently with the kitchen",
    publishedDate: "25-July-2025",
    image: blogthumb11,
    description:
      "When considering modular interiors, the initial association is frequently with the kitchen ",
  },

  {
    id: 13,

    slug: "Built-for-Your-Life",
    title:
      "Built for Your Life: Why Custom Modular Interiors Are Redefining Urban Homes",
    subtitle:
      "In today’s fast-paced cities, space is a luxury — and so is time. ",
    publishedDate: "04-Aug-2025",
    image: blogthumb13,
    description:
      "In today’s fast-paced cities, space is a luxury — and so is time.  ",
  },
];
function Blog() {
  {
    /*Popup scripts start */
  }
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    // Show the popup after 30 seconds
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 5000); // Change to 30000 for 30 seconds

    // Clear the timer on cleanup
    return () => clearTimeout(timer);
  }, []);

  const closePopup = () => {
    setShowPopup(false);
  };
  {
    /*Popup scripts End */
  }

  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: false, // Only animate once
      disable: () => window.innerWidth < 768, // Disable on mobile (screen width < 768px)
    });
  }, []);

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <div>
      {/* {showPopup && <OnloadPopup closePopup={closePopup} />} */}
      <div className="Banner">
        <img src={banner} alt="" />
        <h1>Blogs</h1>
      </div>
      <div>
        <div className="home-section-3-bg">
          <div className="wrapper">
            {/* <div className="blog-sec">
              
            
              <div className="blog-item">
                <Link to="/">
                  <img src={blogthumb1} alt="" />
                  <div className="blog-content">
                    <h4>Modern Cabinets </h4>
                    <h5>Lorem Ipsum</h5>
                  </div>
                </Link>
              </div>
            </div> */}
            <div className="blog-sec">
              {[...blogs].reverse().map((blog) => (
                <div key={blog.id} className="blog-item">
                  <Link to={`/blog/${blog.slug}`} onClick={scrollToTop}>
                    <img src={blog.image} alt={blog.title} />
                    {/* <p>{new Date(blog.publishedDate).toDateString()}</p> */}

                    <div className="blog-content">
                      <div className="published1">
                        <b>Published</b>: {blog.publishedDate}
                      </div>
                      <h4>{blog.title}</h4>
                      <h5>{blog.subtitle}</h5>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Blog;
